import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpErrorResponse, } from '@angular/common/http';
import { BehaviorSubject, catchError, filter, Observable, switchMap, take, throwError } from 'rxjs';
import { LoginApiService } from 'src/app/features/login/services/login-api.service';
import { environment } from 'src/environments/environment';
import { UserService } from '../../Services/user.service';
import { UserProfile } from '../../Models/interfaces/user-details';
import { toasterMsg } from '../../Constants/static';
import { ApiResponse } from '../../Models/interfaces/responseData';


@Injectable({
	providedIn: 'root'
})
export class InterceptorService implements HttpInterceptor {

	private tryingRefreshing = false;
	private refreshTokenSubject: BehaviorSubject<any> = new BehaviorSubject<any>(null);
	apiDomain: string = environment.apiDomain;
	accessToken: string='';

	constructor(private sharedApi: LoginApiService,
		private userService: UserService) { }
	intercept(
		httpRequest: HttpRequest<any>,
		next: HttpHandler,
	): Observable<HttpEvent<any>> {

		if (!window.navigator.onLine) {
			const error = {
				message: 'No Network Connection!'
			};
			return throwError(new HttpErrorResponse({ error }));
		} else {

			let authToken = this.userService.getUserInfo()?.accessToken
			let sourceReq = httpRequest.clone();
			if (authToken) {
				sourceReq = sourceReq.clone({
					setHeaders: {
						Authorization: 'Bearer ' + authToken,
					}
				});


			}
			httpRequest = this.addAuthorization(httpRequest, authToken);
			return next.handle(sourceReq).pipe(
				catchError((error) => {
					let message = 'Something went wrong!';
					if (error instanceof HttpErrorResponse && (!error.status || error.status === 403)) {
						message = 'We encountered an issue';
					}
					if (error instanceof HttpErrorResponse && (error.status === 401)) {

						if (error.error.status == 'Token-expired' || error.error.error_code == 'ERR_TKN_EXP') {
							return this.handle401Error(httpRequest, next);
						} else if (error.error.status == 'Expired' || error.error.error_code == 'ERR_TKN_INV') {
							this.sharedApi.userLogout().subscribe();
						}
						this.sharedApi.userLogout();
						return throwError({ status: error.status, message: toasterMsg.status401 });
					}
					if (error instanceof HttpErrorResponse && error.error instanceof Blob && error.error.type === "application/json") {
						return throwError(error.error)
					}
					if (error?.error?.message) {
						return throwError(error.error)

					}
					return throwError({ status: error.status, message: message });
				})

			);
		}
	}


	private handle401Error(request: HttpRequest<ApiResponse>, next: HttpHandler) {
		if (!this.tryingRefreshing) {
			this.tryingRefreshing = true;
			this.refreshTokenSubject.next(null);
			return this.userService.refreshToken().pipe(
				switchMap((token: ApiResponse) => {
					const userProfile: UserProfile = {
						userDetails: this.userService.getUserInfo()?.userDetails,
						accessToken: token.data?.access_token,
						refreshToken: token.data?.refresh_token
					}
					this.userService.setUserInfo(userProfile);

					this.tryingRefreshing = false;
					this.refreshTokenSubject.next(token.data?.access_token);
					return next.handle(this.addAuthorization(request, token.data?.access_token));

				}),
				catchError((error) => {
					console.log(error,'sdsdd');
					
					if (error.error.status == 'Expired' || error.error.error_code == 'ERR_TKN_INV') {
						this.sharedApi.userLogout().subscribe();
					}
					return throwError(error);
				})
			);

		} else {
			return this.refreshTokenSubject.pipe(
				filter(token => token != null),
				take(1),
				switchMap(jwt => {
					return next.handle(this.addAuthorization(request, jwt));
				}));
		}
	}

	addAuthorization(httpRequest: HttpRequest<any>, token?: string) {
		return httpRequest = httpRequest.clone({
			setHeaders: {
				Authorization: 'Bearer ' + token,
			}
		});
	}
}
